import { scale } from '@components/frame';
import { HANDLE_STROKE_WIDTH, HANDLE_VISUAL_RADIUS } from '@v2/components/imageHandling/components/DrawingCanvas/constants';
import { getBBox, getHandles } from '@v2/components/imageHandling/components/DrawingCanvas/helpers';
import type { Annotation, ManageSelectionHandlesResult } from '@v2/components/imageHandling/components/DrawingCanvas/types';

export interface UseManageSelectionHandlesParams {
  annotation: Annotation;
  /** Current image zoom — used to keep handles a constant on-screen size regardless of zoom. */
  zoom: number;
}

/**
 * Computes the handles + bbox for the selected annotation and pre-normalises handle radius /
 * stroke width by the current zoom. The dots are rendered inside a `transform: scale(zoom)`
 * wrapper, so dividing here keeps the on-screen size constant — without it, handles get huge
 * at high zoom and obscure the annotation.
 */
export const useManageSelectionHandles = ({ annotation, zoom }: UseManageSelectionHandlesParams): ManageSelectionHandlesResult => {
  const handles = getHandles(annotation);
  const bbox = getBBox(annotation);

  const z = zoom || 1;
  const handleRadius = scale(HANDLE_VISUAL_RADIUS + 1) / z;
  const handleStrokeWidth = scale(HANDLE_STROKE_WIDTH) / z;

  return { handles, bbox, handleRadius, handleStrokeWidth };
};
